/*eslint-disable */

import appFooter from '@/components/public/common/footer/';
import {bus} from '@/main';
import supportChatbot from '@/components/private/support-chatbot';
import usersidebar from '@/components/usersidebar/index';

var $ = window.jQuery = require('jquery');
export default {
  name: 'userDashboard',
  components: {
    'app-footer': appFooter,
    'user-sidebar': usersidebar,
    supportChatbot
  },
  props: [],
  data() {
    return {
      preloader: true
    }
  },
  computed: {

  },
  mounted() {
    bus.$emit('showHomeMenuBtn', true);
    bus.$emit('showQuizMenubtn', true);
    bus.$emit('showMyProfileMenu', false);
    this.$store.dispatch('getAuthHeader');

    $('#sidebarToggleRight').on('click', function(){
      $('.dashboard').removeClass('show');
      $('.usersidebar').removeClass('show');
      $('.usersidebar-right').removeClass('show');
      $('.mobilemenu-icon').removeClass('open');
    })
    this.preloader = false;
    $('.app-loader').hide()
    $('.routeloader').hide()
    if (process.env.NODE_ENV == 'production') {
      this.$scriptLoader.load("https://www.googletagmanager.com/gtag/js?id=UA-152519411-1")
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'UA-152519411-1');
    }
  },
  methods: {

  },
  beforeCreate: function() {
    $('body').addClass('dashboard');
    var root = document.getElementsByTagName('html')[0]; // '0' to assign the first (and only `HTML` tag)
    root.setAttribute('class', 'dashboardhtml');
    var images = ["img1", "img2", "img3", "img4"]
    var size = images.length;
    var x = Math.floor(size * Math.random());
    if (x < images.length) {
      // console.log(x, "Check The Random Value")
      if(x === 0){
        $('body').removeClass('random_dash_img_2');
        $('body').addClass('random_dash_img_1');
      }else if(x === 1){
        $('body').removeClass('random_dash_img_1');
        $('body').addClass('random_dash_img_2');
      }else if(x === 2){
        $('body').removeClass('random_dash_img_2');
        $('body').addClass('random_dash_img_1');
      }else if(x === 3){
        $('body').removeClass('random_dash_img_1');
        $('body').addClass('random_dash_img_2');
      }
    }
  },
  beforeRouteLeave: function(to, from, next) {
    $('body').removeClass('dashboard');
    $('body').removeClass('random_dash_img_2');
    $('body').removeClass('random_dash_img_1');
    next();
  },
  created() {

  }
}